export type ControlLang = "hr" | "en";

/**
 * Main Control Center header scope. Only the owner real-pilot panel is real;
 * every other panel remains synthetic demo data.
 */
export function controlDataScopeLabel(lang: ControlLang, pilotPanelActive: boolean): string {
  if (!pilotPanelActive) {
    return lang === "en" ? "synthetic data" : "sintetički podaci";
  }
  return lang === "en"
    ? "real bounded pilot report; other panels stay synthetic"
    : "stvarni ograničeni pilot; ostali paneli ostaju sintetički";
}
